'use client';

import { PopOver, usePopOver } from "./pop-over";

export function ToolTip({ children, toolTip }: React.PropsWithChildren<{ toolTip: string }>) {
  const { show, hide, open } = usePopOver();
  const onClick = ({ target, nativeEvent }: React.MouseEvent) => { target.dispatchEvent(new MouseEvent('click', nativeEvent)); }

  return <>
    <PopOver content={toolTip} open={open} onMouseEnter={show} onMouseLeave={hide} onClick={onClick}>
      {children}
    </PopOver>
  </>;
}
